import selectReferenceImage from '%paysera_seat_selection/js/seatSelection/redux/component/workflow/selectors/selectReferenceImage';

export default selectReferenceImage;
